import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel'


const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: 0,
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing.unit * 2,
    },
});
  
const RFSelectField=props=>{
    const { 
        classes,
        input, label, customStyle, meta: { touched, error }, datas, codeField, descField
    } = props;
    let errorStyle=touched && error?{color: 'red'}:null
    
    return (
        <FormControl className={classes.formControl}>
          <InputLabel style={errorStyle} htmlFor="RFSelectField">{label}</InputLabel>
          <Select
            style={customStyle}
            {...input}
            onChange={input.onChange}
            input={<Input name="rfSelectField" id="RFSelectField" />}
          >
            { datas.length >0 ? datas.map( data => (
                <MenuItem key={data[codeField]} value={data[codeField]}  >{data[descField]}</MenuItem>
                )) : <MenuItem key={'code1'} value={''} /> }

          </Select>
          <FormHelperText style={errorStyle}>{touched && error?error:''}</FormHelperText>
        </FormControl>
    )
}

RFSelectField.propTypes = {
    codeField: PropTypes.string.isRequired,
    descField: PropTypes.string.isRequired
}

export default withStyles(styles)(RFSelectField);


// WEBPACK FOOTER //
// ./src/components/ReduxFormComps/RFSelectField.js